/**
 * @generated SignedSource<<8d82cb122628716679452c870d4fd8bd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NonReferralAcceptanceArtist_referral$data = {
  readonly recipientDisplayName: string;
  readonly " $fragmentType": "NonReferralAcceptanceArtist_referral";
};
export type NonReferralAcceptanceArtist_referral$key = {
  readonly " $data"?: NonReferralAcceptanceArtist_referral$data;
  readonly " $fragmentSpreads": FragmentRefs<"NonReferralAcceptanceArtist_referral">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NonReferralAcceptanceArtist_referral",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recipientDisplayName",
      "storageKey": null
    }
  ],
  "type": "IndifyToArtistReferralNode",
  "abstractKey": null
};

(node as any).hash = "7d327a8c1dd5e22f512a481d0f683c2c";

export default node;
